import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}

function SvgIconStep({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 37 12"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <circle cx={6} cy={6} r={6} fill="currentColor" />
      <circle cx={31} cy={6} r={6} fill="currentColor" />
      <path stroke="currentColor" strokeWidth={4} d="M6 6h25" />
    </svg>
  );
}

export default SvgIconStep;
